var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company-dropdown" },
    [
      _c("vue-select", {
        attrs: {
          options: _vm.options,
          label: _vm.usedLabelField,
          reduce: _vm.reduceFn,
          clearable: _vm.clearable,
          placeholder: _vm.placeholder,
          disabled: _vm.disabled || _vm.isLoading,
        },
        model: {
          value: _vm.internalValue,
          callback: function ($$v) {
            _vm.internalValue = $$v
          },
          expression: "internalValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }